import React from 'react';

import './Loader.scss';

const Loader = ({ size = 'large', className = '' }) => (
  <div className={`dot-pulse ${className}`}>
    <div className={`single-dot-1 ${size}`} />
    <div className={`single-dot-2 ${size}`} />
    <div className={`single-dot-3 ${size}`} />
  </div>
);

export default Loader;
